import Reveal from "@/components/base/Reveal";
import specialOfferBg from "@/assets/special-offer-bg.webp";

export default function SpecialOffer() {
  const openRequest = () => {
    window.location.href = "https://hurma.work/request-2/";
  };

  return (
    <section id="offer" className="scroll-mt-16 relative overflow-hidden bg-background-50">
      {/* background image */}
      <div className="absolute inset-0">
        <img
          src={specialOfferBg}
          alt="HURMA спецпропозиція"
          title="Спецпропозиція HURMA"
          className="h-full w-full object-cover object-top"
        />
      </div>

      <div className="relative mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-16">
        <div className="relative text-center">
          <Reveal delay={100}>
            <h2 className="font-heading text-4xl font-extrabold leading-tight tracking-tight text-foreground-950 md:text-6xl">
              3 місяці <span className="peach-gradient-text">вигідніше з HURMA</span>
            </h2>
          </Reveal>
        </div>

        <div className="mt-10 md:mt-12">
          {/* offer cards */}
          <Reveal delay={200}>
            <div className="relative mx-auto w-full max-w-4xl">
              <div className="grid grid-cols-1 overflow-hidden rounded-[2rem] lg:grid-cols-2">
                {/* card 1 — discount */}
                <div className="flex items-center justify-center gap-5 bg-primary-50 px-6 py-9 md:gap-6 md:px-8 md:py-11">
                  <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-500 md:h-20 md:w-20">
                    <i className="ri-price-tag-3-line text-3xl md:text-4xl"></i>
                  </span>
                  <div className="text-left">
                    <p className="font-heading text-6xl font-extrabold leading-none tracking-tight text-primary-500 md:text-8xl">
                      −10%
                    </p>
                    <p className="mt-4 text-lg leading-snug text-foreground-950 md:mt-5 md:text-2xl">
                      при оплаті 3 місяців
                      <br />
                      будь-якого тарифу
                    </p>
                  </div>
                </div>

                {/* card 2 — community */}
                <div className="flex items-center justify-center gap-5 bg-accent-50 px-6 py-9 md:gap-6 md:px-8 md:py-11">
                  <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700 md:h-20 md:w-20">
                    <i className="ri-group-line text-3xl md:text-4xl"></i>
                  </span>
                  <div className="text-left">
                    <p className="font-heading text-4xl font-extrabold leading-[1.08] tracking-tight text-foreground-950 md:text-5xl">
                      Ком&apos;юніті
                      <br />
                      рекрутерів
                    </p>
                    <p className="mt-4 text-lg font-bold leading-snug text-foreground-950 md:mt-5 md:text-2xl">
                      безплатно
                      <span className="block text-base font-normal text-foreground-700 md:text-xl">
                        на весь період підписки
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              {/* plus — sits exactly on the seam */}
              <span className="absolute left-1/2 top-1/2 z-10 hidden h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white text-accent-600 ring-1 ring-secondary-200 lg:flex">
                <i className="ri-add-line text-4xl"></i>
              </span>
            </div>
          </Reveal>
        </div>

        {/* CTA */}
        <Reveal delay={400}>
          <div className="mt-10 flex flex-col items-center text-center md:mt-12">
            <button
              type="button"
              onClick={openRequest}
              className="inline-flex items-center gap-3 whitespace-nowrap rounded-full bg-primary-500 px-9 py-4 text-lg font-semibold text-white transition-colors hover:bg-primary-600 cursor-pointer"
            >
              Отримати пропозицію
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
              Розкажемо деталі та допоможемо під&apos;єднати інтеграцію з OLX Робота.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}